const logo = require('../images/logo.png')

export default logo;